import * as React from 'react';
import { Grid } from 'react-flexbox-grid';
import { compose, withStateHandlers, lifecycle, withHandlers } from 'recompose';
import { default as RenderToggle } from 'material-ui/Toggle';
import ExportIcon from 'material-ui/svg-icons/file/file-download';
import * as moment from 'moment';
import { get, map } from 'lodash';

import Date from '@inqool/uas-web-core/es/components/controls/DateTime/DateTime';
import RemoteAutoComplete from '@inqool/uas-web-core/es/components/controls/AutoCompleteRemote';
import { ExportOfficersMovement } from '@modules/maps/dialogs/ExportMovementOfficers';
import { ModalButton } from '@components/modalButton/ModalButton';
import { stringifyObject } from '@utils/utils';
import { mapUrl } from '../Map';

const wrapperStyle = {
  width: '160px'
};
const DATE_FORMAT = 'YYYY-MM-DD';
const layersLabel = 'metropolis:oracle_officer_location_points';

const enhance = compose<any, { handleLayers: (layers: any) => void }>(
  withStateHandlers(
    {
      active: false,
      from: moment()
        .subtract(1, 'months')
        .format(DATE_FORMAT),
      to: moment().format(DATE_FORMAT),
      officer: ''
    },
    {
      handleStateActive: state => () => ({ ...state, active: !state.active }),
      handleStateFrom: state => from => ({ ...state, from: from && stringifyObject(from) }),
      handleStateTo: state => to => ({ ...state, to: to && stringifyObject(to) }),
      handleStateOfficer: state => officer => ({ ...state, officer })
    }
  ),
  withHandlers({
    updateUrl: ({ handleLayers, layers }) => (newProps, oldProps) => {
      const { from: oldFrom, to: oldTo, officer: oldOfficer, active: oldActive } = oldProps;
      const { from: newFrom, to: newTo, officer: newOfficer, active: newActive } = newProps;

      if (oldFrom !== newFrom || oldTo !== newTo || oldOfficer !== newOfficer || oldActive !== newActive) {
        if (!newFrom || !newTo || !newOfficer || !newActive) {
          handleLayers(layers.filter(({ layers: label }) => label !== layersLabel));
          return;
        }

        const url = mapUrl + `?viewParams=datetime_from:${newFrom};datetime_to:${newTo};officer_id:${newOfficer};`;

        handleLayers([
          ...layers.filter(({ layers: label }) => label !== layersLabel),
          {
            layers: layersLabel,
            url,
            active: true
          }
        ]);
      }
    }
  }),
  lifecycle<any, any>({
    componentDidUpdate(prevProps: any) {
      const { updateUrl } = this.props;
      updateUrl(this.props, prevProps);
    }
  })
);

const View: React.SFC<any> = ({
  handleStateFrom,
  handleStateTo,
  handleStateOfficer,
  handleStateActive,
  from,
  to,
  officer,
  active
}) => (
  <div>
    <Grid fluid={true}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', margin: '0 10px', alignItems: 'center' }}>
            <h4 style={{ marginRight: '5px' }}>Aktivovat</h4>
            <RenderToggle toggled={!!active} onToggle={handleStateActive} />
          </div>
          {[
            { label: 'Datum od:', name: 'dateFromOfficer', onChange: handleStateFrom, value: from },
            { label: 'Datum do:', name: 'dateToOfficer', onChange: handleStateTo, value: to }
          ].map(({ label, ...restProps }, i) => (
            <div key={i} style={{ display: 'flex', margin: '0 10px' }}>
              <h4 style={{ marginRight: '5px' }}>{label}</h4>
              <Date wrapperStyle={wrapperStyle} dateOnly={true} {...restProps} />
            </div>
          ))}
          <div style={{ display: 'flex', margin: '0 10px' }}>
            <h4 style={{ marginRight: '5px' }}>Strážník</h4>
            <RemoteAutoComplete
              name={'officer'}
              value={officer}
              labelFunction={o => get(o, 'fullName')}
              valueFunction={o => get(o, 'id')}
              placeholder={'Vyberte ze seznamu'}
              onChange={val => handleStateOfficer(val)}
              url="/metropolis/api/hr/employees?pageSize=-1"
              style={{
                display: 'flex',
                alignItems: 'center'
              }}
            />
          </div>
        </div>

        <div style={{ height: '60px' }}>
          {map(
            [
              {
                label: 'Export',
                icon: <ExportIcon />,
                style: { marginBottom: 10, marginRight: 10 },
                ModalComponent: ExportOfficersMovement,
                initialValues: {},
                dialogStyles: {
                  style: { paddingTop: '5vh' },
                  contentStyle: {
                    paddingTop: 10,
                    transform: 'none'
                  },
                  bodyStyle: { padding: '0', overflow: 'auto' }
                }
              }
            ],
            (item, key) => <ModalButton disabled={false} key={key} {...item} />
          )}
        </div>
      </div>
    </Grid>
  </div>
);

export const MovementOfficers = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/maps/tabs/MovementOfficers.tsx